export default "__VITE_PUBLIC_ASSET__8b6504db__"